export enum SkilledNeedsFormField {
  SKILLED_NEED = 'skilled-needs/skilledNeed',
  SKILLED_NEED_NAME = 'skilledNeedName',
  SKILLED_NEED_SCORE = 'skilledNeedScore',
  SKILLED_NEED_NOTE = 'skilledNeedNote',
  SKILLED_NEED_PREVIOUS_NOTE = 'skilledNeedPreviousNote',
  SKILLED_NEED_DESCRIPTION = 'skilledNeedDescription'
}
